import { messageBelongsToUserFilter, messageDateComparator } from "@/helpers/helpers";
import { MESSAGE_STATUS } from "@/helpers/constants";
import { scrollToTheBottom } from "@/helpers/DOMHelper";

export default {
  /**
   * Get private messages
   * @param state {Object}
   * @param getters
   * @param rootState
   * @return {function(): (this)}
   */
  privateMessages: (state, getters, rootState) => {
    let messages;
    if (state.privateChatTarget) {
      let userUUID = state.privateChatTarget.userUUID;
      messages = [...state.privateMessages]
        .filter(message => messageBelongsToUserFilter(message, userUUID))
        .sort(messageDateComparator);
    } else {
      messages = [...state.privateMessages]
        .filter(msg => {
          const isMessageFromNetworkUser = rootState.users.userConnections.find(u =>
            messageBelongsToUserFilter(msg, u.targetUserUUID)
          );
          return (
            (state.privateChatFilters.NETWORK && isMessageFromNetworkUser) ||
            (state.privateChatFilters.OTHER && !isMessageFromNetworkUser)
          );
        })
        .sort(messageDateComparator);
    }
    scrollToTheBottom("privateMessages");
    return messages;
  },

  /**
   * Network messages count
   * @param state
   * @param getters
   * @param rootState
   * @return {number}
   */
  networkMessagesCounter: (state, getters, rootState) => {
    return state.privateMessages.filter(msg => {
      return Boolean(rootState.users.userConnections.find(u => messageBelongsToUserFilter(msg, u.targetUserUUID)));
    }).length;
  },

  /**
   * Other messages count
   * @param state
   * @param getters
   * @param rootState
   * @return {number}
   */
  otherMessagesCounter: (state, getters, rootState) => {
    return state.privateMessages.filter(msg => {
      return !rootState.users.userConnections.find(u => messageBelongsToUserFilter(msg, u.targetUserUUID));
    }).length;
  },

  /**
   * Get room messages
   * @param state {Object}
   * @param getters
   * @param rootState
   * @return {*[]}
   */
  roomMessages: (state, getters, rootState) => {
    if (rootState.users.user && rootState.users.user.is_admin) {
      return [...state.roomMessages].sort(messageDateComparator);
    } else {
      return [...state.roomMessages].filter(m => m.messageStatus !== MESSAGE_STATUS.HIDDEN).sort(messageDateComparator);
    }
  },

  /**
   * Get table messages
   * @param state {Object}
   * @param getters
   * @param rootState
   * @return {*[]}
   */
  tableMessages: (state, getters, rootState) => {
    if (rootState.users.user && rootState.users.user.is_admin) {
      return [...state.tableMessages].sort(messageDateComparator);
    } else {
      return [...state.tableMessages]
        .filter(m => m.messageStatus !== MESSAGE_STATUS.HIDDEN)
        .sort(messageDateComparator);
    }
  }
};
